<template lang="html">
	<section class="take-place master-transactions column">
		<div class="white-box row ctn-transactions-reminder">
			<div class="ctn-icon">
				<span class="icon-operations-folder"></span>
			</div>
			<div class="column labels">
				<div class="title">
		  		Vous avez <span class="bold">{{ operations.length }} opération{{ (operations.length > 1) ? 's' : '' }}</span>
				</div>
				<div class="label">
			  	Pour un total encours de <span class="bold">{{ computedTotal | moneyFilter }} €</span>
				</div>
			</div>
			<router-link :to="{ name: 'MyTransactionsAdd' }" class="btn btn-red ctn-icon">
				<span class="icon-button-new-mission"></span>
				Nouvelle opération
			</router-link>
		</div>
		<div class="label">
			Opérations d'investissements
		</div>
		<keep-alive>
			<ag-table :rows="computedRows" :columns="cols" :customOptions="options"/>
		</keep-alive>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'TableOperations',
	data () {
		return {
			cols: [
				{ name: 'Client', field: 'client', cellType: 'light', width: 130 },
				{ name: 'Nom', field: 'name', cellType: 'light', width: 220 },
				{ name: 'Date', field: 'date', cellType: 'date', width: 260 },
				{ name: 'Lettre de mission', field: 'letter', cellType: 'statusMission', width: 180 },
				{ name: 'Rapport de mission', field: 'cr', cellType: 'statusMission', width: 180 },
				{ name: 'Montant', field: 'amount', cellType: 'light', width: 160 }
			],
			options: {
				onRowClicked: (data) => {
					this.$router.push({name: 'MyTransactionsEdit', params: { id: data.data.id }})
				}
			}
		}
	},
	mounted () {
		this.$store.dispatch('getOperations')
	},
	methods: {
		resolveDocs (mission, type) {
			const doc = mission.documents.filter(doc => doc.sub_category === type)[0]
			if (doc) {
				if (doc.universign_status === 'ready') {
					return 'En Attente'
				} else if (doc.universign_status === 'completed') {
					return 'Signé'
				} else {
					return 'En Attente'
				}
			} else {
				return 'À envoyer'
			}
		}
	},
	computed: {
		computedTotal () {
			let total = 0
			this.operations.forEach((operation) => {
				total += operation.total_value
			})

			return total
		},
		...mapGetters({
			operations: 'operations'
		}),
		computedRows () {
			const rows = []
			this.operations.forEach((operation) => {
				rows.push({
					id: operation.id,
					client: operation.client.user.first_name + ' ' + operation.client.user.last_name,
					name: operation.title,
					date: this.$moment(operation.created_at, 'DD/MM/YYYY HH:mm'),
					letter: this.resolveDocs(operation, 'Lettre de mission'),
					cr: this.resolveDocs(operation, 'Rapport de mission'),
					amount: this.$options.filters.moneyFilter(operation.total_value) + ' ' + operation.currency
				})
			})
			return rows
		}
	},
	filters: {
		moneyFilter (value) {
			const val = value.toString()
			let result = ''
			const integer = val.split('.')[0].split('')
			const decimal = val.split('.')[1]
			while (integer.length > 3) {
				result = '.' + integer.splice(integer.length - 3, integer.length).join('') + result
			}
			result = integer.join('') + result
			result += ',' + (decimal || '00')

			return result
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Table.vue?abdd42ce